import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { withTranslation } from 'react-i18next'
import { getFormValues } from 'redux-form'
import ModalLicencias from '../../../components/admin/licencias/ModalLicencias'
import { comprobarEntorno } from '../../../actions/auth/auth'
import { abrirModalLicencias, cerrarModalLicencias, submitLicencia } from '../../../actions/admin/licencias/licencias'
import {openSimpleModal} from '../../../actions/common'

export function mapStateToProps (state) {
  return {
    ...state.licencias,
    auth: state.auth,
    combos: {comboModulos: state.combos.comboModulos, comboCustomizacion: state.combos.comboCustomizacion}
  }
}

export function mapDispatchToProps (dispatch) {
  return {
    actions: bindActionCreators({
      abrirModalLicencias,
      cerrarModalLicencias,
      submitLicencia,
      comprobarEntorno,
      openSimpleModal
    }, dispatch)
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(ModalLicencias))